export class AuthInfo {
  public accessToken: string | null;
  public refreshToken: string | null;
  public id: string | null;
  public name: string | null;
  public email: string | null;
  public role: string | null;
  public permissions: string[];
  public exp = 0;
  public optimalUserId: string | null = null;

  constructor(
    token: string,
    id: string,
    name: string,
    email: string,
    role: string,
    permissions: string[],
    exp: number,
    optimalUserId: string
  ) {
    this.accessToken = token;
    this.id = id;
    this.name = name;
    this.email = email;
    this.role = role;
    this.permissions = permissions;
    this.exp = exp;
    this.optimalUserId = optimalUserId;
  }
}
